import React, { useState } from "react";
import violentometro from './images/violentometro.png';
import derechoslegales from './images/derechoslegales.jpeg';
import apoyopsicologico from './images/apoyopsicologico.jpeg';
import violenciafisica from './images/violenciafisica.avif';
import violenciaPsicologica from './images/violenciaPsicologica.jpeg';
import ViolenciaSexual from './images/ViolenciaSexual.jpeg';
import ViolenciaEconomica from './images/ViolenciaEconomica.jpeg';
import ViolenciaSimbolica from './images/ViolenciaSimbolica.jpeg';
import ViolenciaPatrimonial from './images/ViolenciaPatrimonial.avif';
import evento1 from './images/accesos/CentrosJusticia.jpg';
import evento2 from './images/accesos/Num_Emergencia.png';
import evento3 from './images/accesos/Test.png';
import evento4 from './images/accesos/Podcast.jpg';
import { useNavigate } from 'react-router-dom';


const TiposViolencia = ({ title, content }) => {


  return (
    <div id="Tiposviolencia" className="text-center font-sans" style={{ backgroundColor: '#f2e9e4', color: '#f2e9e4' }}>
        

            <section className="text-gray-800 p-8 text-justify" style={{ backgroundColor: '#ebe0f0' }}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-xl font-semibold mb-4">Violencia Física</h3>
                        <img src={violenciafisica} alt="Violencia Física" className="w-full h-32 object-cover mb-4" />
                        <p>Golpes, empujones, agresiones que causan daño corporal.</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-xl font-semibold mb-4">Violencia Psicológica</h3>
                        <img src={violenciaPsicologica} alt="Violencia Psicológica" className="w-full h-32 object-cover mb-4" />
                        <p>Humillaciones, insultos, manipulación, aislamiento, control emocional.</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-xl font-semibold mb-4">Violencia Sexual</h3>
                        <img src={ViolenciaSexual} alt="Violencia Sexual" className="w-full h-32 object-cover mb-4" />
                        <p>Abuso, violación, acoso sexual, explotación sexual.</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-xl font-semibold mb-4">Violencia Económica</h3>
                        <img src={ViolenciaEconomica} alt="Violencia Económica" className="w-full h-32 object-cover mb-4" />
                        <p>Control de los recursos financieros, limitación del acceso al trabajo, privación económica.</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-xl font-semibold mb-4">Violencia Simbólica</h3>
                        <img src={ViolenciaSimbolica} alt="Violencia Simbólica" className="w-full h-32 object-cover mb-4" />
                        <p>Representaciones y actitudes en medios y cultura que refuerzan la desigualdad de género.</p>
                    </div>

                    <div className="bg-white rounded-lg shadow-lg p-6">
                        <h3 className="text-xl font-semibold mb-4">Violencia Patrimonial</h3>
                        <img src={ViolenciaPatrimonial} alt="Violencia Patrimonial" className="w-full h-32 object-cover mb-4" />
                        <p>Robo, destrucción de objetos o bienes que pertenecen a la víctima.</p>
                    </div>
                </div>


            </section>
    </div>
  );
};

export default TiposViolencia;
